{
  "title": "Prestidigitation",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "10 feet",
  "components": "V, S",
  "duration": "Up to 1 hour",
  "description": [
    "This spell is a minor magical trick that novice spellcasters use for practice. You create one of the following magical effects within range:",
    "You create an instantaneous, harmless sensory effect, such as a shower of sparks, a puff of wind, faint musical notes, or an odd odor.",
    "You instantaneously light or snuff out a candle, a torch, or a small campfire.",
    "You instantaneously clean or soil an object no larger than 1 cubic foot.",
    "You chill, warm, or flavor up to 1 cubic foot of nonliving material for 1 hour.",
    "You make a color, a small mark, or a symbol appear on an object or a surface for 1 hour.",
    "You create a nonmagical trinket or an illusory image that can fit in your hand and that lasts until the end of your next turn.",
    "If you cast this spell multiple times, you can have up to three of its non-instantaneous effects active at a time, and you can dismiss such an effect as an action."
  ],
  "spellLists": [
    "artificer",
    "bard",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
